module.exports = "/assets/data/4e9b08461e148890329d4a9b2ae9135b-NG6.data.json";